import { ColumnFiltersState, OnChangeFn } from "@tanstack/react-table";
import { ORDERS_SU2M } from "@/client-admin/types.gen";
import { columns } from "./columns";
import { DataTable } from "./data-table";

type Props = {
  rows: ORDERS_SU2M[];
  columnFilters: ColumnFiltersState;
  onColumnFiltersChange: OnChangeFn<ColumnFiltersState>;
};

export function SumOrdersTable({ rows, columnFilters, onColumnFiltersChange }: Props) {
  return (
    <DataTable
      columns={columns}
      data={rows}
      getRowId={(row) => row.orderId}
      columnFilters={columnFilters}
      onColumnFiltersChange={onColumnFiltersChange}
    />
  );
}
